<template>
  <div class="cbg-white-container input-container">
    <div class="col-sm-12 row ml-0 pl-0 pr-0">
      <div class="row">
        <div class="form-group col-sm-6 col-md-3">
          <label for>Filter</label>
          <div class="search-div position-relative">
            <input
              type="text"
              placeholder="Search"
              class="form-control"
              v-model="searchName"
              @input="throttledMethod"
            />
            <div
              v-if="searchName !== ''"
              class="search-svg position-absolute"
              @click="clearSearch()"
            >
              <crossSVG />
            </div>
          </div>
        </div>
        <div class="form-group col-sm-6 col-md-3">
          <div class="position-relative">
            <label for>Status</label>
            <select name id class="form-control" v-model="forStatus" @change="list()">
              <option value>All</option>
              <option value="PENDING">Pending</option>
              <option value="APPROVED">Approved</option>
              <option value="REJECT">Rejected</option>
            </select>
            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="table-div overflow-auto">
      <table class="table userlistTable">
        <thead>
          <tr class="table-success">
            <th v-if="tabs === 0 || tabs === 1">Against</th>
            <th v-else>Against Center</th>
            <th>Created By</th>
            <th>Generated On</th>
            <th>Subject</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in listData" :key="index">
          <tr>
            <td
              v-if="tabs === 0 || tabs === 1"
              class="text-capitalize"
            >{{ item.against_to && item.against_to.full_name }}</td>
            <td v-else>
              {{
              item.against_to_center &&
              item.against_to_center.general &&
              item.against_to_center.general.name
              }}
            </td>
            <td class="text-capitalize">{{ item.raised_by && item.raised_by.full_name }}</td>
            <td>{{ getDate(item.created_at) }}</td>
            <td>{{ item.subject }}</td>
            <td class="capitalize-text">{{ item.inappropriate_status }}</td>
            <td>
              <v-btn
                class="btn btn-primary"
                @click="toggleDetails(item, index)"
              >{{ Boolean(item._toggled) ? "Hide" : "Show" }}</v-btn>
            </td>
          </tr>
          <tr>
            <td colspan="6" class="p-0 border-0">
              <CCollapse
                class="col-sm-12 p-0"
                :show="Boolean(item._toggled)"
                :duration="collapseDuration"
              >
                <CCardBody class="col-sm-12 d-flex text-left">
                  <p
                    class="text-danger mr-2"
                    v-if="item.inappropriate_status == 'REJECT'"
                  >Rejected on : {{ getDate(item.rejectedOn) }}</p>
                  <span
                    v-if="
                      permissions.includes('VIEW_REASON_REPORT_INAPPROPRIATE')
                    "
                  >
                    <v-btn
                      size="sm"
                      class="btn btn-primary ml-1"
                      v-if="item.inappropriate_status == 'REJECT'"
                      @click="reasonModal = true"
                    >View Reason</v-btn>
                  </span>
                  <p
                    class="text-success mr-2 mb-0 mt-2"
                    v-if="item.inappropriate_status == 'APPROVED'"
                  >Approved on : {{ getDate(item.approvedOn) }}</p>
                  <span
                    v-if="
                      permissions.includes(
                        'CAN_APPROVE_REJECT_REPORT_INAPPROPRIATE'
                      )
                    "
                  >
                    <v-btn
                      size="sm"
                      class="btn btn-success ml-1"
                      v-if="item.inappropriate_status == 'PENDING'"
                      @click="openSwal(item, true)"
                    >Approve</v-btn>
                  </span>
                  <span
                    v-if="
                      permissions.includes(
                        'CAN_APPROVE_REJECT_REPORT_INAPPROPRIATE'
                      )
                    "
                  >
                    <v-btn
                      size="sm"
                      class="btn btn-danger mx-1"
                      v-if="item.inappropriate_status == 'PENDING'"
                      @click="openRejectModal(item)"
                    >Reject</v-btn>
                  </span>
                  <span
                    v-if="
                      permissions.includes(
                        'VIEW_DESCRIPTION_REPORT_INAPPROPRIATE'
                      )
                    "
                  >
                    <v-btn
                      size="sm"
                      class="btn btn-primary ml-1"
                      v-if="item.imageval"
                      @click="viewAffidavit(item)"
                    >View Affidavit</v-btn>
                  </span>
                  <span
                    v-if="
                      permissions.includes(
                        'VIEW_DESCRIPTION_REPORT_INAPPROPRIATE'
                      )
                    "
                  >
                    <v-btn
                      size="sm"
                      class="btn btn-primary ml-1"
                      @click="informationDisplay = true"
                    >Description</v-btn>
                  </span>

                  <v-btn size="sm" class="btn btn-primary ml-1" @click="goToChat(item.raised_by._id, item.raised_by.full_name)">Chat</v-btn>

                  <v-btn size="sm" class="btn btn-primary ml-1">Call</v-btn>

                  <v-btn size="sm" class="btn btn-primary ml-1">Email</v-btn>

                  <div>
                    <CModal title="Description" color="dark" :show.sync="informationDisplay">
                      <div class="col-sm-12">
                        <h6>{{ item.description }}</h6>
                      </div>
                      <template #header>
                        <h6 class="modal-title">Description</h6>
                      </template>
                      <template #footer>
                        <v-btn @click="informationDisplay = false" class="btn btn-danger">Cancel</v-btn>
                      </template>
                    </CModal>

                    <!-- reason modal start -->
                    <CModal title="Reason" color="dark" :show.sync="reasonModal">
                      <div class="col-sm-12">
                        <h6>{{ item.rejected_reason }}</h6>
                      </div>
                      <template #footer>
                        <CButton @click="reasonModal = false" color="danger">Cancel</CButton>
                      </template>
                    </CModal>
                    <!-- reason modal end -->
                  </div>
                </CCardBody>
              </CCollapse>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination
      class="pagination-block"
      :recordPerPage="recordPerPage"
      :currentPage="currentPage"
      :total="total"
      @changePage="changePage"
    />
    <CModal
      v-if="affidavitModal"
      :show.sync="affidavitModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      size="lg"
      color="dark"
      :details="affidavitData"
    >
      <!-- <CImg
          v-if="
            typeOfDocument == 'png' ||
              typeOfDocument == 'jpeg' ||
              typeOfDocument == 'jpg' ||
              typeOfDocument == 'webp'
          "
          :src="affidavitData.imageval"
          block
          class="mb-2"
          width="470"
          height="600"
      />-->
      <div
        v-if="
          typeOfDocument == 'png' ||
          typeOfDocument == 'jpeg' ||
          typeOfDocument == 'jpg' ||
          typeOfDocument == 'webp'
        "
        class="text-center"
      >
        <image-view
          zoomImg="true"
          :src="affidavitData.imageval"
          :classes="'mb-2'"
          v-if="checkIfImage(affidavitData.imageval)"
        ></image-view>
        <pdf-component :src="affidavitData.imageval" :styles="'width: 100%; height: 800px'" v-else></pdf-component>
      </div>
      <embed v-else-if="typeOfDocument == 'pdf'" :src="src" style="width: 100%; height: 800px" />
      <template #header>
        <h6 class="modal-title">Affidavit</h6>
        <download-image
          :imgSrc="affidavitData.imageval"
          v-if="checkIfImage(affidavitData.imageval)"
        ></download-image>
        <CButtonClose @click="affidavitModal = false" />

        <!-- <CButtonClose @click="affidavitModal = false" class="text-white" /> -->
      </template>
      <template #footer>
        <v-btn @click="affidavitModal = false" class="btn btn-danger">Cancel</v-btn>
      </template>
    </CModal>
    <CModal
      :show.sync="rejectModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      size="lg"
      color="dark"
      :details="rejectData"
    >
      <CTextarea
        label="Reason"
        name="reason"
        v-model="rejectReason"
        placeholder="Reason"
        horizontal
        rows="2"
      />
      <span class="text-danger">{{ errors.first("reason") }}</span>
      <template #header>
        <h6 class="modal-title">Reason for Reject</h6>
        <!-- <CButtonClose @click="rejectModal = false" class="text-white" /> -->
      </template>
      <template #footer>
        <v-btn @click="rejectModal = false" class="btn btn-danger">Cancel</v-btn>
        <v-btn
          class="btn btn-success"
          @click="acceptAndReject(rejectData, false)"
          v-if="rejectReason"
        >Submit</v-btn>
      </template>
    </CModal>
  </div>
</template>
<script>
import { pickSvg } from "@/views/SVG";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import config from "@/config.js";
import _ from "lodash";
import { mapGetters, mapState } from "vuex";
const Image = () => import("@/components/image.vue");
const Pdf = () => import("@/components/pdf.vue");
import ChatMixin from "@/common/ChatMixin";
const downloadImage = () => import("@/components/downloadImage.vue");

import Swal from "sweetalert2";
export default {
  mixins: [ChatMixin],
  $_veeValidate: {
    validator: "new"
  },
  components: {
    "image-view": Image,
    "pdf-component": Pdf,
    ...pickSvg("crossSVG"),
    pagination: () => import("@/views/common/Pagination"),
    downloadImage
  },
  data() {
    return {
      dayJS,
      collaps: false,
      details: [],
      collapseDuration: 0,
      listData: [],
      toggle: false,
      rejectModal: false,
      rejectData: {},
      rejectReason: "",
      affidavitModal: false,
      affidavitData: {},
      typeOfDocument: "",
      src: "",
      currentPage: 1,
      totalPage: 1,
      recordPerPage: 10,
      forStatus: "",
      searchName: "",
      informationDisplay: false,
      reasonModal: false,
      total: 0
    };
  },
  computed: {
    ...mapGetters({
      userDetails: "getUserDetails",
      token: "getToken",
      permissions: "getPermissions"
    })
  },
  props: ["tabs"],
  watch: {
    tabs: {
      handler(newValue) {
        if (newValue == 0 || newValue) {
          this.list();
        }
      }
    }
  },
  mounted() {
    this.list();
  },
  methods: {
    checkIfImage(str) {
      if (str.split(".").pop() !== "pdf") return true;
      return false;
    },
    clearSearch() {
      this.searchName = "";
    },

    openSwal(item, valid) {
      Swal.fire({
        title: "Are you sure",
        text: "Need message",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Report it!",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          this.acceptAndReject(item, valid);
        }
      });
    },

    getDate(date) {
      return dayJS(date).format("DD-MM-YYYY h:mm A");
    },
    toggleDetails(item, index) {
      this.$set(this.listData[index], "_toggled", !item._toggled);
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.list();
    },

    throttledMethod: _.debounce(function(e) {
      this.list();
    }, 1000),

    list() {
      let role = "patient";
      switch (this.tabs) {
        case 0:
          role = "patient";
          break;
        case 1:
          role = "doctor";
          break;
        case 2:
          role = "pharmacy";
          break;
        case 3:
          role = "diagnostics-lab";
          break;
        case 4:
          role = "bloodbank";
          break;
        case 5:
          role = "ambulance";
          break;
      }

      let arr = [];
      let obj = {
        page: this.currentPage,
        record_per_page: this.recordPerPage,
        search_text: this.searchName ? this.searchName : "",
        status: this.forStatus ? this.forStatus : "ALL",
        against_to_role: role
      };
      let url = `${config.BASE_URL}api/v2/admin/ticket/inappropriate`;
      this.$http.post(url, obj).then(response => {
        if (response.body.status) {
          this.listData = [...response.body.data.data.list];
          this.totalPage =
            response.body.data.data.total_records / this.recordPerPage;
          if (response.body.data.data.total_records % this.recordPerPage !== 0)
            this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
          this.total = response.body.data.data.total_records;
        }
      });
    },
    openRejectModal(item) {
      this.rejectModal = true;
      this.rejectData = item;
    },
    viewAffidavit(item) {
      this.affidavitModal = true;
      let fileDetails = item && item.imageval.split(".");
      this.typeOfDocument = fileDetails[fileDetails.length - 1];
      this.src = item.imageval;
      this.affidavitData = item;
    },
    acceptAndReject(item, valid) {
      let url = `${config.BASE_URL}api/v2/admin/ticket/inappropriate/accept-reject`;
      let obj = {
        record_id: item._id,
        is_valid: valid,
        rejected_reason: valid ? "" : this.rejectReason
      };
      this.$http.post(url, obj).then(response => {
        if (response.body.status) {
          this.rejectModal = false;
          this.list();
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  .btn-primary {
    color: #321fdb;
    background-color: transparent;
  }
  tr {
    &:last-child {
      td {
        border-bottom: 1px solid #d8dbe0;
      }
    }
  }
  thead {
    th {
      border-bottom: 1px solid #d8dbe0;
    }
  }

  th,
  td {
    width: 25%;
    &:last-child {
      text-align: right;
    }
  }
  .collaps-tr {
    th,
    td {
      width: 100%;
      &:last-child {
        text-align: left;
      }
    }
  }
  .capitalize-text {
    text-transform: capitalize;
  }
  // .text-danger {
  //   font-size: 0.7vw;
  // }
}
</style>
